import { signOut } from "../../lib/auth-client";

// Routes that require authentication - user will be redirected on logout
export const AUTHENTICATED_ROUTES = [
	"/dashboard",
	"/settings",
	"/billing",
	"/api-keys",
	"/dashboard/settings",
	"/dashboard/billing",
	"/dashboard/api-keys",
	"/business/new",
	"/upgrade-success",
	"/upgrade-error",
];

// Check if current path requires authentication
export function isAuthenticatedRoute(pathname: string): boolean {
	// Check exact matches
	if (AUTHENTICATED_ROUTES.includes(pathname)) return true;
	// Check all dashboard sub-routes (e.g. /dashboard/brand/assets)
	if (pathname.startsWith("/dashboard/")) return true;
	return false;
}

export async function signOutAndNavigate(pathname: string) {
	const result = await signOut();

	if (result?.error) {
		throw new Error(result.error.message || "Failed to sign out");
	}

	if (isAuthenticatedRoute(pathname)) {
		window.location.href = "/";
		return;
	}

	window.location.reload();
}

// Dashboard nav items for the header
export const dashboardNavItems = [
	{ label: "Home", path: "/dashboard", segment: "home" },
	{ label: "Chat", path: "/dashboard/chat", segment: "chat" },
	{ label: "Connect", path: "/dashboard/connect", segment: "connect" },
	{ label: "Posts", path: "/dashboard/posts", segment: "posts" },
] as const;
